module.exports = __webpack_public_path__ + "img/inventario_2.3c4cbbdc.png";